import { AnyAction, combineReducers } from 'redux';
import { actions } from '../actions';
import { State } from '../types';

const defaultState: State = {
    settings: {
        appInstallationId: null
    },
    applicationStatus: {
        openWindows: []
    },
    userStatus: {
        installationActive: false,
        permissions: [],
        hoursPerDay: 0,
        worklogsFromDate: "",
    },
    worklogs: {
        myWorklogs: [],
        myWorklogStatus: {
            from: new Date(0),
            totalDelta: 0,
            holidaysSpent: 0,
            holidaysLeft: 0,
        }
    },
    inProgress: [],
    billingData: {
        customers: [],
    },
    billingStatus: {
        lastUpdateSecondsAgo: -1,
        enableTempoFetch: false,
    }
}

function settingsReducer(state: State["settings"] = defaultState.settings, action: AnyAction): State["settings"] {
    if (actions.updateSettingsAction.match(action)) {
        return { ...state, ...action.payload };
    }
    return state;
}

function applicationStatusReducer(state: State["applicationStatus"] = defaultState.applicationStatus, action: AnyAction): State["applicationStatus"] {
    if (actions.openApplicationWindowAction.match(action)) {
        if (state.openWindows.indexOf(action.payload.name) > -1) {
            return state;
        }
        return { ...state, openWindows: [...state.openWindows, action.payload.name] }
    }
    if (actions.closeApplicationWindowAction.match(action)) {
        let newOpenWindows = [...state.openWindows];
        newOpenWindows.splice(newOpenWindows.indexOf(action.payload.name), 1)
        return { ...state, openWindows: newOpenWindows }
    }
    return state;
}

function userStatusReducer(state: State["userStatus"] = defaultState.userStatus, action: AnyAction): State["userStatus"] {
    if (actions.updateUserStatusAction.match(action)) {
        return { ...action.payload }
    }
    return state;
}

function worklogsReducer(state: State["worklogs"] = defaultState.worklogs, action: AnyAction): State["worklogs"] {
    if (actions.setMyWorklogsAction.match(action)) {
        return { ...state, myWorklogs: action.payload.reverse() }
    }
    if (actions.setMyWorklogStatusAction.match(action)) {
        return { ...state, myWorklogStatus: action.payload }
    }
    return state;
}

function inProgressReducer(state: State["inProgress"] = defaultState.inProgress, action: AnyAction): State["inProgress"] {
    if (actions.inProgressAction.match(action)) {
        return [...state, action.payload]
    }
    if (actions.notInProgressAction.match(action)) {
        let newState = [...state]
        newState.splice(newState.indexOf(action.payload), 1)
        return newState
    }
    return state;
}

function billingDataReducer(state: State["billingData"] = defaultState["billingData"], action: AnyAction): State["billingData"] {
    if (actions.updateBillingDataAction.match(action)) {
        return action.payload;
    }
    return state;
}

function billingStatusReducer(state: State["billingStatus"] = defaultState["billingStatus"], action: AnyAction): State["billingStatus"] {
    if (actions.updateBillingStatusAction.match(action)) {
        return action.payload;
    }
    return state;
}

export default combineReducers({
    settings: settingsReducer,
    applicationStatus: applicationStatusReducer,
    userStatus: userStatusReducer,
    worklogs: worklogsReducer,
    inProgress: inProgressReducer,
    billingData: billingDataReducer,
    billingStatus: billingStatusReducer,
});
